const url = "https://dynaslope.com.ph";
export const host = `${url}:5001`;
export const base_url = url;
export const storage_host = `${url}:8080`;
export const CBEWSL_SITE = 29;
export const CBEWSL_SITE_CODE = "mar";
export const CBEWSL_SITE_NAME = "marirong";
export const CBEWSL_SITE_LOCATION = "Brgy. Marirong, Leon, Iloilo";
export const WSS_KEY =
  "833c2bfed00681143663109354ee65f951f963797f0507a93bb13ea26b69557920cbde40ca6466540cddfb39cb0a4e03e0717dc26b7c0e655cba80bffedaa407";
